import { createFileRoute } from "@tanstack/react-router";
import { CopyrightPolicy } from "@/lib/lazyPages";
import { SEO } from "@/config/seoConfig";
import { seoHead } from "@/lib/seo/head";

export const Route = createFileRoute("/copyright-policy")({
  head: () => seoHead(SEO.copyrightPolicy),
  component: CopyrightPolicy,
});
